<template>
    <TopNav></TopNav>
        <h1>Калькулятор погашення боргу</h1>
        <fieldset>
        <legend>Калькулятор погашення боргу</legend>
            <label for="balancedOwedId">Заборгованість:</label> <input type="number" v-model.number="balancedOwed" id="balancedOwedId" step="any" min="0"> ₴
            <br>
            <label for="interestRateId">Річна процентна ставка:</label> <input type="number" v-model.number="interestRate" id="interestRateId" step="any" min="0"> %
            <br>
            <label for="monthlyPaymentId">Щомісячний платіж:</label> <input type="number" v-model.number="monthlyPayment" id="monthlyPaymentId" step="any" min="0"> ₴
            <br><br>
            Термін погашення: близько <output class="blue">{{ outputMonthsToPayOff() }} місяців</output>
        </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
    name: 'DebtRepayment',
    data() {
            return {
                balancedOwed: 0,
                interestRate: 0,
                monthlyPayment: 0
            }
        },
        components: {
            TopNav
        },
        methods: {
            outputMonthsToPayOff: function () {
                const monthlyInterestRate = this.interestRate / (100 * 12);
                const dividend = Math.log(this.monthlyPayment / (this.monthlyPayment - monthlyInterestRate * this.balancedOwed));
                const divisor = Math.log(1 + monthlyInterestRate);
                const months = dividend / divisor;
                return Math.ceil(months);
            },
        },
    };
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

body {
    margin: 1em auto;
    margin-top: 0;
    max-width: 40em;
    font-family: Arial, Helvetica, sans-serif;
}

label {
    display: inline-block;
    width: 220px;
}

footer section a {
    margin: 20px;
}

.blue {
    color: blue;
}
</style>
